import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { faqs } from '../data/social';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-16 sm:py-24" data-id="element-110" data-mp="1cg1jdsu5ifb1">
      <div className="mx-auto max-w-3xl" data-id="element-111" data-mp="2a2s0u51905uk">
        <SectionHeading eyebrow="Frequently Asked Questions" title="Your Questions, Answered" data-id="element-112" data-mp="2a1h0kf70hg87" />

        <div className="mt-10 divide-y divide-ink/10 rounded-3xl bg-cream px-5 sm:px-8" data-id="element-113" data-mp="253xb0j4v5h0y">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-114" data-mp="1v46iuo3rze41" data-mpi={i}>
                <h3 data-id="element-115" data-mp="1v7c5lwoxm3wl">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[17px] font-bold text-ink focus:outline-none focus-visible:text-brand" data-id="element-116" data-mp="oonpvjk9kdoh">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-117" data-mp="1aoiv820is71l" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-118" data-mp="16np9nfajv4bv">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-119" data-mp="rz2txch0gak4">
                      <p className="pb-5 text-[16px] leading-relaxed text-muted" data-id="element-120" data-mp="2pmn4twkkpw05">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10" data-id="element-121" data-mp="2fw2ailbxndn1">
          <CTAButton label="My Questions Are Answered — I’m In" data-id="element-122" data-mp="2fx3k0ldavs2n" />
        </div>
      </div>
    </section>;
}